import type { AbsenceKind } from '../components/plantafel/plantafelTypes';

export type AbsenceBarStyle = {
  bg: string;
  border: string;
  /** Kräftiger linker Rand – unterscheidet Abwesenheiten von Aktivitäts-Balken. */
  accent: string;
  text: string;
};

function absenceTokens(kind: AbsenceKind): AbsenceBarStyle {
  return {
    bg: `var(--absence-${kind}-bg)`,
    border: `var(--absence-${kind}-border)`,
    accent: `var(--absence-${kind}-accent)`,
    text: `var(--absence-${kind}-text)`,
  };
}

/**
 * Abwesenheiten: ruhige Fläche + Akzentstreifen (nicht die Vollflächen der Aktivitätstypen).
 * Die konkreten Farben stehen als Theme-Tokens in `index.css`, damit Light und Dark Mode
 * denselben Balken unterschiedlich einfärben und ein Theme-Wechsel ohne Re-Render greift.
 */
const ABSENCE_BAR_STYLES: Record<AbsenceKind, AbsenceBarStyle> = {
  urlaub: absenceTokens('urlaub'),
  krank: absenceTokens('krank'),
  feiertag: absenceTokens('feiertag'),
  freischicht: absenceTokens('freischicht'),
  stundenabbau: absenceTokens('stundenabbau'),
  fehlzeit: absenceTokens('fehlzeit'),
  sonderurlaub: absenceTokens('sonderurlaub'),
  krankengeld: absenceTokens('krankengeld'),
};

export function absenceBarStyle(kind: AbsenceKind): AbsenceBarStyle {
  return ABSENCE_BAR_STYLES[kind];
}
